/* sb-dc-sizeonly.js — retire the "Change product · finishing" dialog.
   2026-09-05.

   History in two steps. First the dialog lost its product catalogue, because
   product choice moved to the Design Templates picker. Then it lost its reason
   to exist at all: size and quantity are already in the left Size panel, and
   finishing now sits in the right rail (sb-dc-finrail.js). So the button that
   opened it is hidden.

   Hidden, not deleted — in the header and in the dialog's own markup. The app
   still uses the applied product for size presets, prices and finishing rules,
   and sb-dc-popupbackdrop.js still reads the selected product out of that
   dialog's markup to decide whether to offer the frame. Removing any of it
   would take those with it. Delete the CSS below and everything returns.

   Known consequence, agreed with the store: the dialog also carried the
   material choice (vinyl vs fabric within a family). That is now only
   reachable by picking a different product — through Design Templates or a
   product page.

   Diagnostics: window.__dcSizeOnly. */
(function () {
  'use strict';

  var state = { hiddenButtons: 0 };
  window.__dcSizeOnly = state;

  function css() {
    if (document.getElementById('sbdc-sizeonly-css')) return;
    var st = document.createElement('style');
    st.id = 'sbdc-sizeonly-css';
    st.textContent = '[data-sbdc-hide="sizebtn"]{display:none !important}';
    document.head.appendChild(st);
  }

  function hideButton() {
    var bs = document.querySelectorAll('button, a');
    for (var i = 0; i < bs.length; i++) {
      if (bs[i].dataset.sbdcHide) continue;
      var t = (bs[i].textContent || '').replace(/\s+/g, ' ').trim();
      /* Both spellings: the original label and the one this file used to set. */
      if (/^change product/i.test(t) || /^size and options$/i.test(t)) {
        bs[i].dataset.sbdcHide = 'sizebtn';
        state.hiddenButtons++;
      }
    }
  }

  css();
  var t = setInterval(function () { try { hideButton(); } catch (e) {} }, 350);
  window.addEventListener('pagehide', function () { clearInterval(t); });
})();
